import {createComboUnitId} from '../helpers';

export interface ComboUnitInterface {
    getUnitId(): string;
    getPlayerIds(): string[];
    getLineupIds(): string[];
    getQuantity(): number;
    isUsedInLineup(): boolean;
}

export class ComboUnit implements ComboUnitInterface {
    private readonly unitId: string = '';
    private constructor(
        private readonly playerIds: string[],
        private readonly lineupIds: string[],
        isUniversal: boolean,
    ) {
        this.unitId = createComboUnitId(this.playerIds, isUniversal);
    }
    public getUnitId(): string {
        return this.unitId;
    }
    public getPlayerIds(): string[] {
        return this.playerIds;
    }
    public getLineupIds(): string[] {
        return this.lineupIds;
    }
    public getQuantity(): number {
        return this.lineupIds.length;
    }
    public isUsedInLineup(): boolean {
        return this.lineupIds.length > 0;
    }
    public static createPrimary(playerIds: string[], lineupIds: string[] = []): ComboUnitInterface {
        return new ComboUnit(playerIds, lineupIds, false);
    }
    public static createUniversal(playerIds: string[], lineupIds: string[] = []): ComboUnitInterface {
        return new ComboUnit(playerIds, lineupIds, true);
    }
}
